import React, { useState } from "react";

export const ModalEULA = ({ onAccept, onReject }) => {
  const [aceptado, setAceptado] = useState(false);

  const handleCheckboxChange = (e) => {
    setAceptado(e.target.checked);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Acuerdo de Licencia de Usuario Final (EULA)</h2>
        <div
          className="modal-body"
          style={{
            maxHeight: "300px",
            overflowY: "auto",
            textAlign: "left",
            whiteSpace: "pre-line",
            fontSize: "14px",
          }}
        >
          <p>
            <strong>Aplicación de Registro de Jornadas Laborales Ticaje Grupo SIL</strong>
            {"\n\n"}
            <strong>Última actualización:</strong> 1 de agosto de 2025
          </p>

          <p>
            Este Acuerdo de Licencia de Usuario Final (“EULA”) regula el acceso y uso de la aplicación informática (la “Aplicación”) proporcionada por WeMotion Technology S.L (el “Proveedor”) a los usuarios autorizados por la entidad contratante, MTTO INDUSTRIAL MIYE, SL (la “Empresa”).

            Al utilizar esta Aplicación, usted (“Usuario”) acepta expresamente los términos de este acuerdo. Si no está de acuerdo con alguno de ellos, debe abstenerse de utilizarla.
          </p>

          <p><strong>1. Objeto del EULA</strong>{"\n"}
            La Aplicación está diseñada para facilitar el registro y control de la jornada laboral del personal de la Empresa. El Proveedor ofrece el software bajo un modelo Software como Servicio (SaaS) y se encarga exclusivamente de su mantenimiento técnico, alojamiento y disponibilidad.
          </p>

          <p><strong>2. Relación de las partes</strong>{"\n"}
            La Empresa es el cliente del servicio y la responsable del tratamiento de los datos personales conforme al Reglamento (UE) 2016/679 (RGPD) y la Ley Orgánica 3/2018 (LOPDGDD).{"\n\n"}
            El Proveedor actúa como encargado del tratamiento, prestando servicios técnicos bajo las instrucciones de la Empresa.{"\n\n"}
            El Usuario accede a la Aplicación en calidad de empleado o colaborador autorizado por la Empresa.
          </p>

          <p><strong>3. Transparencia, trazabilidad y conservación</strong>{"\n"}
            La Aplicación garantiza la trazabilidad completa de los datos, registrando todas las acciones relevantes (altas, modificaciones, accesos, eliminaciones), incluyendo la identidad del usuario, fecha y hora.{"\n\n"}
            Además, el sistema implementa copias de seguridad periódicas de la base de datos con fines de restauración, verificación de integridad y conservación de un histórico de cambios, conforme a los principios de responsabilidad proactiva y seguridad del tratamiento establecidos en el RGPD.
          </p>

          <p><strong>4. Datos personales y privacidad</strong>{"\n"}
            El tratamiento de sus datos personales está sometido a:
            {"\n"}- El Reglamento General de Protección de Datos (RGPD).
            {"\n"}- La Ley Orgánica 3/2018, de Protección de Datos Personales y garantía de los derechos digitales (LOPDGDD).
            {"\n"}- Las políticas de privacidad establecidas por la Empresa.{"\n\n"}
            El Proveedor no accede ni utiliza los datos personales para fines propios y se compromete a implementar medidas de seguridad técnica y organizativa adecuadas (art. 32 RGPD).
          </p>

          <p><strong>5. Obligaciones del Usuario</strong>{"\n"}
            Usted se compromete a:
            {"\n"}- Utilizar la Aplicación únicamente para los fines laborales indicados por la Empresa.
            {"\n"}- No manipular ni introducir datos falsos o ajenos.
            {"\n"}- No interferir con el funcionamiento del software.
            {"\n"}- Mantener la confidencialidad de sus credenciales de acceso.
          </p>

          <p><strong>6. Limitación de responsabilidad</strong>{"\n"}
            El Proveedor no será responsable de:
            {"\n"}- El uso indebido o no autorizado de la Aplicación.
            {"\n"}- La veracidad o exactitud de los datos introducidos.
            {"\n"}- Las decisiones laborales o contractuales tomadas por la Empresa con base en la información gestionada en la Aplicación.{"\n\n"}
            El Proveedor se limita a garantizar la disponibilidad razonable y el funcionamiento técnico del servicio.
          </p>

          <p><strong>7. Propiedad intelectual</strong>{"\n"}
            El software, su diseño, código fuente, estructura y documentación son propiedad exclusiva del Proveedor. El Usuario no adquiere ningún derecho de propiedad intelectual o industrial sobre la Aplicación.
          </p>

          <p><strong>8. Duración y finalización</strong>{"\n"}
            Este EULA se aplica mientras el Usuario mantenga acceso autorizado a la Aplicación. El acceso podrá ser revocado por decisión de la Empresa o en caso de incumplimiento del presente acuerdo.
          </p>

          <p><strong>9. Legislación aplicable y jurisdicción</strong>{"\n"}
            Este acuerdo se rige por la legislación española. Para cualquier controversia derivada de su interpretación o cumplimiento, las partes se someten a los Juzgados y Tribunales de Almería, salvo que la normativa aplicable disponga otra cosa.
          </p>
        </div>

        <div style={{ marginTop: "1rem" }}>
          <input
            type="checkbox"
            id="checkbox-eula"
            checked={aceptado}
            onChange={handleCheckboxChange}
          />
          <label htmlFor="checkbox-eula" style={{ marginLeft: "0.5rem" }}>
            He leído y acepto los términos del acuerdo.
          </label>
        </div>

        <div className="modal-footer" style={{ marginTop: "1rem" }}>
          <button
            className="btn btn-primary"
            onClick={onAccept}
            disabled={!aceptado}
          >
            Aceptar
          </button>
          <button className="btn btn-danger" onClick={onReject}>
            Rechazar
          </button>
        </div>
      </div>
    </div>
  );
};
